import { MailpieceStatus } from '@leadgen/models/client'
import _ from 'lodash'

class StringFormatter {
  formatFileName = (file: string) => {
    const lastIndexOfDot = file.lastIndexOf('.')
    const fileWithoutNumbers = file.substring(0, lastIndexOfDot).replace(/\d+/g, '')
    return _.startCase(fileWithoutNumbers)
  }
  formatLetterStatus = (status: MailpieceStatus) => {
    switch (status) {
      case 'cancelled':
        return 'Cancelled'
      case 'delivered':
        return 'Delivered'
      case 'received':
        return 'Being printed'
      case 'handed_over':
        return 'With courier'
      case 'in_transit':
        return 'In transit'
      case 'local_delivery':
        return 'In transit'
      case 'producing':
        return 'Being printed'
      default:
        return status === 'test' ? 'Delivered' : status
    }
  }
}

export default new StringFormatter()
